import { Container, Grid, Section } from '@/components/Core'
import CardTeaser from '@/components/Project/Cards/CardTeaser'
import { Lib } from '@/types'
import { memo } from 'react'
import SectionTeaserFragment from './query'
export interface SectioTeaserProps {
  data: Lib.FragmentOf<typeof SectionTeaserFragment>
}

const SectioTeaser = ({ data }: SectioTeaserProps) => {
  const { teasers, _modelApiKey } = data

  return (
    <Section
      className={'py-vertical-large'}
      mainWrapper={false}
      sectionName={_modelApiKey}
      anim="section-fade-in"
    >
      <Container>
        <Grid>
          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            <div className="gap-gutter grid md:grid-cols-2">
              {teasers.map((teaser, k) => (
                <CardTeaser
                  data={teaser}
                  key={k}
                  anim="fade-in"
                  animDelayFactor={k}
                />
              ))}{' '}
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectioTeaser)
